// The mobile content image is full-bleed (w-screen) and keeps its natural aspect ratio
// (h-auto), so its rendered height scales with device WIDTH — a fixed pixel height can't
// track that across devices (a 288px guess that fit a 390pt phone is wrong on anything
// wider or narrower, and left the loading skeleton's drawer sitting a little low). We
// instead reserve space using a typical 3:2 landscape-hero ratio (height = width × 2/3)
// until the real image loads and re-measures. Measured on a 390pt-wide phone, real hero
// images land ≈260px (≈3:2).
export const MOBILE_IMAGE_HEIGHT_RATIO = 2 / 3;

// Fallback for non-layout contexts (SSR / tests without a real viewport width).
export const DEFAULT_MOBILE_IMAGE_HEIGHT_FALLBACK = 288;

/**
 * Device-relative assumed image height: viewport width × the 3:2 ratio. Recomputed on
 * each call so it reflects the actual device (and orientation) rather than a baked-in
 * pixel guess. Used by use-mobile-scroll for the real content's initial tray position
 * before the image loads and re-measures.
 */
export const getDefaultMobileImageHeight = (): number => {
  if (typeof window !== 'undefined' && window.innerWidth > 0) {
    return Math.round(window.innerWidth * MOBILE_IMAGE_HEIGHT_RATIO);
  }
  return DEFAULT_MOBILE_IMAGE_HEIGHT_FALLBACK;
};

export const IMAGE_HEIGHT_OFFSET = 20;
export const ANIMATION_DURATION = 300;
